import { ITracker } from './tracker.types';

export class Tracker implements ITracker {
    tracker: any    
    selectedKey: string  
    template: any
    grantInfo: any
    steps: Array<any>
    MappedStories: any

    constructor(tracker: ITracker) {
        this.tracker = tracker.tracker || {};
        this.template = tracker.template;
        this.selectedKey = tracker.selectedKey || 'projectInfo';
        this.grantInfo = tracker.grantInfo || {};
        this.steps = tracker.steps || [];
        this.MappedStories = tracker.MappedStories || [];
    }
}
